import { storageGet, storageRemove, storageSet } from '@faceup/utils'
import { useCallback } from 'react'
import { useClient } from '../App/ClientProvider'

export enum StorageKeys {
  Language = 'LANGUAGE',
  User = 'USER_DATA',
  JWT = 'JWT',
}

export const useStorage = () => {
  const { client } = useClient()

  const isPersistent = client === 'app'

  const set = useCallback(
    (key: StorageKeys, data: string, forcePersistent?: boolean) => {
      storageSet((forcePersistent ?? isPersistent) ? 'localStorage' : 'sessionStorage', key, data)
    },
    [isPersistent]
  )

  const get = useCallback(
    (key: StorageKeys) => {
      const persistentItem = storageGet('localStorage', key)
      const temporaryItem = storageGet('sessionStorage', key)
      // For consistent getter with setter
      return isPersistent ? persistentItem : temporaryItem
    },
    [isPersistent]
  )

  const remove = useCallback((key: StorageKeys) => {
    storageRemove('localStorage', key)
    storageRemove('sessionStorage', key)
  }, [])

  return { set, get, remove }
}
